import { Component, effect, ElementRef, input, model, signal, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-smart-search-tag',
  imports: [TranslateModule, NgbTooltip],
  templateUrl: './smart-search-tag.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './smart-search-tag.component.scss',
})
export class SmartSearchTagComponent {
  icon = input<string>();
  placeholder = input<string>();
  inputPlaceholder = input<string>();
  content = input<string>();
  tooltip = input<string>();
  displayTooltip = input(true);
  display = input<string>();
  editable = input(true);
  removable = input(true);
  value = model<string>('');
  localValue = signal<string>('');
  inputRef = viewChild('input', { read: ElementRef });
  focus = false;

  constructor(private elementRef: ElementRef) {
    effect(
      () => {
        const contentValue = this.content() ?? '';
        if (contentValue && !this.value()) {
          this.value.set(contentValue);
        }
      },
      { allowSignalWrites: true }
    );
  }

  onClick() {
    if (!this.editable()) return;
    if (this.content()) return;
    this.focus = true;
    setTimeout(() => this.inputRef()?.nativeElement.focus());
  }

  onDelete() {
    const selection = getSelection();
    const node = this.elementRef.nativeElement as HTMLElement;
    selection?.setPosition(node.previousSibling, node.previousSibling?.textContent?.length ?? 0);
    this.elementRef.nativeElement.remove();
  }
}
